import { z } from "zod/v4";

export const ClassificationReason = z.enum([
  "typo_email_or_name",
  "mismatch_salutation",
]);
export type ClassificationReason = z.infer<typeof ClassificationReason>;
